import api from "@/services/api";

export const productsAdmin = {
    namespaced: true,
    state: () => ({
        products: [],
        loading: false,
        error: null,
    }),
    getters: {
        allProducts: (state) => state.products,
        isLoading: (state) => state.loading,
        hasError: (state) => state.error,
    },
    mutations: {
        SET_PRODUCTS(state, products) {
            state.products = products;
        },
        ADD_PRODUCT(state, product) {
            state.products.push(product);
        },
        UPDATE_PRODUCT(state, updated) {
            const index = state.products.findIndex(p => p.id === updated.id);
            if (index !== -1) state.products[index] = updated;
        },
        DELETE_PRODUCT(state, id) {
            state.products = state.products.filter(p => p.id !== id);
        },
        SET_LOADING(state, val) { state.loading = val; },
        SET_ERROR(state, err) { state.error = err; }
    },
    actions: {
        async fetchProducts({ commit, rootState }) {
            commit("SET_LOADING", true);
            try {
                const token = rootState.admin.token;
                const response = await api.get("/Product/getAll", {
                    headers: { Authorization: `Bearer ${token}` }
                });
                commit("SET_PRODUCTS", response.data);
            } catch (err) {
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async createProduct({ commit, rootState }, product) {
            try {
                const token = rootState.admin.token;
                const response = await api.post("/Product/create", product, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                commit("ADD_PRODUCT", response.data);
            } catch (err) { commit("SET_ERROR", err); }
        },
        async updateProduct({ commit, rootState }, product) {
            try {
                const token = rootState.admin.token;
                const response = await api.put("/Product/update", product, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                commit("UPDATE_PRODUCT", response.data);
            } catch (err) { commit("SET_ERROR", err); }
        },
        async deleteProduct({ commit, rootState }, id) {
            try {
                const token = rootState.admin.token;
                await api.delete(`/Product/delete/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                commit("DELETE_PRODUCT", id);
            } catch (err) { commit("SET_ERROR", err); }
        }
    }
};
